import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=14c62ccc&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c62ccc')) {
      api.createRecord('14c62ccc', component.options)
    } else {
      api.reload('14c62ccc', component.options)
    }
    module.hot.accept("./Policy.vue?vue&type=template&id=14c62ccc&", function () {
      api.rerender('14c62ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/Policy.vue"
export default component.exports